export enum PictogramEnum {
  compactCard = "compactcard",
  fbsHub = "fbs_hub",
  equivolt = "equivolt",
  gaasHub = "gaas_hub",
  gasShop = "gas_shop",
  serviceCard = "servicecard",
  thgQuote = "thg_quote",
  vehicleClassL = "vehicle_class_l",
  vehicleClassM1 = "vehicle_class_m1",
  vehicleClassM3 = "vehicle_class_m3",
  vehicleClassN1 = "vehicle_class_n1",
  vehicleClassN2 = "vehicle_class_n2",
  vehicleClassN3 = "vehicle_class_n3",
  virta = "virta",
  easyMove = "easy_move",
}
export type PictogramName = keyof typeof PictogramEnum;
